import { call, fork, put, take } from 'redux-saga/effects';
import * as actions from 'actions/reqldRates/reqRates';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * get cargo request ldrates
 */

export function* getReqLDRates() {
    const response = yield call(api.getReqLDRates);
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_REQ_LD_RATES.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_REQ_LD_RATES.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetReqLDRates() {
    while (true) {
        yield take(actionTypes.GET_REQ_LD_RATES.REQUEST);
        yield fork(getReqLDRates);
    }
}

export default [
    watchGetReqLDRates,
];



// WEBPACK FOOTER //
// ./app/sagas/reqLDRates.js